// Each view is read on its own: an admin setting never falls back to the user one
export var HELIX_AUDIENCE_CONFIG_KEYS = {
  user: {
    uiMode: 'helixUserUIMode',
    showQuotes: 'helixUserShowQuotes',
    showOverallScore: 'helixUserShowOverallScore',
    showScoreBands: 'helixUserShowScoreBands',
    showTranscript: 'helixUserShowTranscript'
  },
  admin: {
    uiMode: 'helixAdminUIMode',
    showQuotes: 'helixAdminShowQuotes',
    showOverallScore: 'helixAdminShowOverallScore',
    showScoreBands: 'helixAdminShowScoreBands',
    showTranscript: 'helixAdminShowTranscript'
  }
};